var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgehubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9425 0.805117C48.1053 0.681367 47.2681 1.03887 46.9475 1.65762L38.0947 18.9139C37.6672 19.7389 36.6697 19.7801 36.4025 19.7801C36.0997 19.7664 35.12 19.6839 34.7459 18.8451L27.1934 1.71262C26.9441 1.16262 26.2672 0.791367 25.5013 0.791367C24.7353 0.791367 24.0584 1.16262 23.8091 1.71262L16.2566 18.8451C15.8825 19.6839 14.9028 19.7664 14.6 19.7801C14.3506 19.7801 13.3353 19.7389 12.9078 18.9139L4.055 1.65762C3.73438 1.03887 2.89719 0.681367 2.06 0.805117C1.22281 0.942617 0.617188 1.50637 0.617188 2.16637V35.0839C0.617188 37.3664 3.00406 39.2089 5.96094 39.2089H45.0416C47.9984 39.2089 50.3853 37.3664 50.3853 35.0839V2.16637C50.3853 1.50637 49.7797 0.942617 48.9425 0.805117Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgehubIcon);
export default __webpack_public_path__ + "static/media/knowledgehubIcon.8fbbf7976b9db84e2f84b2d0566542ef.svg";
export { ForwardRef as ReactComponent };